// const APIBaseURL = 'http://localhost:3001/v0/';
const APIBaseURL = 'https://printlificapi.printlific.com/v0/';

// const APIBaseURL = 'https://beta.printlific.com/v0/';  
const ImageURL = 'https://printlific.s3.us-east-2.amazonaws.com/'
// const ImageURL = 'https://demo.s3.us-west-2.amazonaws.com/'

export { APIBaseURL, ImageURL }